/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PackageSchema } from '../models/PackageSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PackagesApi {
    /**
     * Get Package
     * @returns PackageSchema OK
     * @throws ApiError
     */
    public static packagesGetPackageGet({
        packageId,
    }: {
        packageId: string,
    }): CancelablePromise<PackageSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/packages/{package_id}',
            path: {
                'package_id': packageId,
            },
        });
    }
    /**
     * Get Packages
     * List packages. <br>Required permission: list_packages
     * @returns PackageSchema OK
     * @throws ApiError
     */
    public static packagesGetPackagesGet(): CancelablePromise<Array<PackageSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/packages/',
        });
    }
}
